import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Carousel } from 'primeng/carousel';

@Component({
  selector: 'app-carousel-essentials',
  templateUrl: './carousel-essentials.component.html',
  styleUrls: ['./carousel-essentials.component.scss']
})
export class CarouselEssentialsComponent implements OnInit{
   @Input() cards: any[] = []; // Las tarjetas a mostrar
  @Input() listData: string = 'General';
  @Input() listIdData: string = 'GENERAL';
  @Input() discountedPriceFatherLoading:boolean =false;

  @ViewChild('carouselGeneral') carouselGeneral!: Carousel; // Acceso al carrusel
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  readonly responsiveOptions = [
    {
      breakpoint: '1400px',
      numVisible: 5,
      numScroll: 5,
    },
    {
      breakpoint: '1200px',
      numVisible: 4,
      numScroll: 4,
    },
    {
      breakpoint: '992px',
      numVisible: 3,
      numScroll: 3,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
    },
    {
      breakpoint: '576px',
      numVisible: 1.5,  // Ajustado a 1.5 para dispositivos muy pequeños
      numScroll: 1.5,
    }
  ];
  isScrollStart = true;
  isScrollEnd = false;
  currentMobilePage = 0;
  constructor( private readonly ref: ChangeDetectorRef,) { }

 ngOnInit(): void {
   
 }

  prevPage() {
    this.carouselGeneral.navBackward(new Event('click'));
  }

  nextPage() {
    this.carouselGeneral.navForward(new Event('click'));
  }

  getTotalPages(): number[] {
    const width = window.innerWidth;
    let itemsPerPage = 5; // default for desktop

    // Determine items per page based on screen width
    if (width <= 576) {
      itemsPerPage = 1.5;
      // Calculate total items excluding first and last card
      const totalItems = Math.max(0, this.cards.length);
      // Calculate pages based on actual items
      const pages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
      return Array(pages).fill(0);
    } else if (width <= 768) {
      itemsPerPage = 2;
    } else if (width <= 992) {
      itemsPerPage = 3;
    } else if (width <= 1200) {
      itemsPerPage = 4;
    }

    const totalItems = Math.max(0, this.cards.length);
    const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
    return Array(totalPages).fill(0);
  }

  @HostListener('window:resize')
  onResize() {
    this.ref.detectChanges();
  }

  goToPage(page: number) {
    this.carouselGeneral.navForward(new Event('click'));
    this.carouselGeneral.page = page;
  }
  scrollNext() {
    const container = this.scrollContainer.nativeElement;
    const scrollAmount = container.clientWidth; // Usar el ancho visible del contenedor
    container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    setTimeout(() => this.updateMobilePageIndicators(), 100); // Dar tiempo a que termine el scroll
  }

  scrollPrev() {
    const container = this.scrollContainer.nativeElement;
    const scrollAmount = container.clientWidth; // Usar el ancho visible del contenedor
    container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    setTimeout(() => this.updateMobilePageIndicators(), 100); // Dar tiempo a que termine el scroll
  }
  updateMobilePageIndicators() {
    const container = this.scrollContainer.nativeElement;
    const tolerance = 5; // Tolerancia fija en píxeles
    
    this.isScrollStart = container.scrollLeft < tolerance;
    this.isScrollEnd = (container.scrollWidth - (container.scrollLeft + container.clientWidth)) < tolerance;
    this.currentMobilePage = Math.floor(container.scrollLeft / container.clientWidth);

    // Forzar detección de cambios
    this.ref.detectChanges();
  }
}
